"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStickyRowContentClassesAndData = exports.stickyRowExists = exports.updateStickyRowPosition = exports.initializeStickyRow = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var agUtils_1 = require("./base/agUtils");
var agApiWrapper_1 = tslib_1.__importDefault(require("./base/agApiWrapper"));
var utils_1 = require("./utils");
var constants_1 = require("./base/constants");
function initializeStickyRow(gridApi) {
    gridApi.setPinnedTopRowData([{}]);
}
exports.initializeStickyRow = initializeStickyRow;
function updateStickyRowPosition(gridApi, apiWrapper) {
    if (apiWrapper === void 0) { apiWrapper = agApiWrapper_1.default; }
    if (!gridApi) {
        return;
    }
    var headerHeight = apiWrapper.getHeaderHeight(gridApi);
    apiWrapper.setPinnedTopRowStyle(gridApi, "top", headerHeight + "px");
    apiWrapper.setPinnedTopRowStyle(gridApi, "padding-right", utils_1.getScrollbarWidth() + "px");
}
exports.updateStickyRowPosition = updateStickyRowPosition;
function stickyRowExists(gridApi, apiWrapper) {
    if (apiWrapper === void 0) { apiWrapper = agApiWrapper_1.default; }
    return !!apiWrapper.getPinnedTopRowElement(gridApi);
}
exports.stickyRowExists = stickyRowExists;
function shouldUpdate(currentScrollPosition, lastScrollPosition, rowHeight) {
    var initialUpdate = currentScrollPosition.top === 0;
    var currentRowIndex = agUtils_1.getGridIndex(currentScrollPosition.top, rowHeight);
    var lastRowIndex = agUtils_1.getGridIndex(lastScrollPosition.top, rowHeight);
    var differentRow = currentRowIndex !== lastRowIndex;
    // when scrolling horizontally update with the same cadence as rows as we don't know where the column borders are
    var horizontalBreakpointDistance = rowHeight;
    var currentHorizontalBreakpoint = agUtils_1.getGridIndex(currentScrollPosition.left, horizontalBreakpointDistance);
    var lastHorizontalBreakpoint = agUtils_1.getGridIndex(lastScrollPosition.left, horizontalBreakpointDistance);
    var differentHorizontalBreakpoint = currentHorizontalBreakpoint !== lastHorizontalBreakpoint;
    return initialUpdate || differentRow || differentHorizontalBreakpoint;
}
function areDataDifferent(previousData, currentData) {
    return (Object.keys(previousData).length !== Object.keys(currentData).length ||
        Object.keys(previousData).some(function (dataItemKey) {
            return previousData[dataItemKey] !== currentData[dataItemKey];
        }));
}
function updateStickyRowContentClassesAndData(currentScrollPosition, lastScrollPosition, rowHeight, gridApi, groupingProvider, apiWrapper) {
    var _a, _b;
    if (!gridApi || !shouldUpdate(currentScrollPosition, lastScrollPosition, rowHeight)) {
        return;
    }
    var firstVisibleRowIndex = agUtils_1.getGridIndex(currentScrollPosition.top, rowHeight);
    var firstVisibleRow = gridApi.getDisplayedRowAtIndex(firstVisibleRowIndex);
    var firstVisibleNodeData = (_a = firstVisibleRow === null || firstVisibleRow === void 0 ? void 0 : firstVisibleRow.data) !== null && _a !== void 0 ? _a : null;
    if (firstVisibleNodeData === null) {
        apiWrapper.removePinnedTopRowClass(gridApi, "gd-visible-sticky-row");
        return;
    }
    apiWrapper.addPinnedTopRowClass(gridApi, "gd-visible-sticky-row");
    var lastRowIndex = agUtils_1.getGridIndex(lastScrollPosition.top, rowHeight);
    // TODO: consider obtaining row-col descriptors from tableDescriptor instead
    var attributeKeys = Object.keys(firstVisibleNodeData).filter(function (colId) {
        var colDef = gridApi.getColumnDef(colId);
        return colDef && colDef.type === constants_1.ROW_ATTRIBUTE_COLUMN;
    });
    var stickyRowData = {};
    var headerItemMap = {};
    attributeKeys.forEach(function (columnId) {
        apiWrapper.removeCellClass(gridApi, columnId, lastRowIndex, "gd-cell-show-hidden");
        // the following value is the same as the current one
        if (groupingProvider.isRepeatedValue(columnId, firstVisibleRowIndex + 1)) {
            // set correct sticky row data
            stickyRowData[columnId] = firstVisibleNodeData[columnId];
            headerItemMap[columnId] = firstVisibleNodeData.headerItemMap[columnId];
        }
        else {
            // if the column has some groups
            if (groupingProvider.isColumnWithGrouping(columnId)) {
                // show the last cell of the group temporarily so it scrolls out of the viewport nicely
                var currentRowIndex = agUtils_1.getGridIndex(currentScrollPosition.top, rowHeight);
                apiWrapper.addCellClass(gridApi, columnId, currentRowIndex, "gd-cell-show-hidden");
            }
        }
    });
    var previousRowData = (_b = gridApi.getPinnedTopRow(0)) === null || _b === void 0 ? void 0 : _b.data;
    var _ignoredHeaders = previousRowData.headerItemMap, _ignoredType = previousRowData.type, _ignoredStyle = previousRowData.subtotalStyle, previousData = tslib_1.__rest(previousRowData, ["headerItemMap", "type", "subtotalStyle"]);
    // set new rowData only if differen to avoid rerendering and flashing of the sticky row
    if (areDataDifferent(previousData, stickyRowData)) {
        var headerItemMapProp = isEmpty_1.default(headerItemMap) ? {} : { headerItemMap: headerItemMap };
        gridApi.setPinnedTopRowData([
            tslib_1.__assign(tslib_1.__assign({}, stickyRowData), headerItemMapProp),
        ]);
    }
}
exports.updateStickyRowContentClassesAndData = updateStickyRowContentClassesAndData;
//# sourceMappingURL=stickyRowHandler.js.map